
import mixins from '@mods/store/template'

import { HttpCarrierAll,HttpCarrierAllList,HttpVirtualWarehouse, HttpGetImporterList, HttpGetSystemPortList, HttpGetCompany } from '@/service/basicdata';
import { HttpGetLevelList, HttpGetCusSystemWareList,HttpAccountByManageList,HttpAccountByOrgList } from "@/service/billing";
import { HttpGetAllWareHouse, HttpGetAllProduct } from "@/service/headlogistics"
import { HttpBillTypeChoseList } from "@/service/newbigaccount"
import { HttpFindAllByInsuranceList } from "@/service/credit"
import { HttpGetAllServiceList, HttpGetAllServiceProductList, HttpGetProductServiceByOrg, HttpGetProductByOrg, HttpGetCustomServiceActiveList, HttpGetCustomServiceAllList, HttpGetCustomServiceProductActiceList, HttpGetCustomServiceProductAllList } from "@/service/fedex";

const list = [
    {
        name: 'virtualWareList',//虚拟仓仓库waretype=5
        ajaxRequest: HttpVirtualWarehouse,
        interceptResponse: data => data.map(item => ({
            value: item.id, label: `${item.code}(${item.title})`, attach: {
                code: item.code,
                warehouseType: item.warehouseType,
            }
        })),
    },
    {
        name: 'firstLevelList',//一级下拉
        ajaxRequest: HttpGetLevelList,
        interceptResponse: data => data.content.map(item => ({ value: item.id, label: item.name })),
        formData: {
            page: 1,
            rows: 1000,
            'search[EQ_level]': 1,
        },
    },
    {
        name: 'secondLevelList',//二级下拉
        ajaxRequest: HttpGetLevelList,
        interceptResponse: data => data.content.map(item => ({ value: item.id, label: item.name })),
        formData: {
            page: 1,
            rows: 1000,
            'search[EQ_level]': 2,
        },
    },
    {
        name: 'thirdLevelList',//三级下拉
        ajaxRequest: HttpGetLevelList,
        interceptResponse: data => data.content.map(item => ({ value: item.id, label: item.name })),
        formData: {
            page: 1,
            rows: 1000,
            'search[EQ_level]': 3,
        },
    },
    {
        name: 'systemWareList',//系统仓库，包含禁用
        ajaxRequest: HttpGetCusSystemWareList,
        interceptResponse: data => data.map(item => ({
            value: item.id, label: `${item.code}(${item.title})`, attach: {
                code: item.code,
                warehouseType: item.warehouseType,
                item:item
            }
        })),
    },
    {
        name: 'manageAccountList',//管理组织下的渠道
        ajaxRequest: HttpAccountByManageList,
        interceptResponse: data => data.map(item => ({
            value: item.flag, label: `${item.flag}`, attach: item
        })),
    },
    {
        name: 'orgAccountList',//组织下的渠道
        ajaxRequest: HttpAccountByOrgList,
        interceptResponse: data => data.map(item => ({
            value: item.flag, label: `${item.flag}`, attach: item
        })),
    },
    // {
    //     name: 'carrierAllList',//所有承运商配置(有效)
    //     ajaxRequest: HttpCarrierAllList,
    //     interceptResponse: data => data.map(item => ({
    //         value: item.carrierCode,
    //         label: item.carrierName ? `${item.carrierCode}(${item.carrierName})` : item.carrierCode,
    //         attach:{
    //             carrierServiceCode:item.carrierServiceCode,
    //             id:item.id
    //         }})),
    // },
    {
        name: 'serviceAllList',//所有物流产品ship
        ajaxRequest: HttpGetAllServiceList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.carrierGroupCode}`,
            attach: item,
        })),
    },
    {
        name: 'customServiceActiveList',//客户有效物流产品ship
        ajaxRequest: HttpGetCustomServiceActiveList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.carrierGroupCode}`,
            attach: item,
        })),
    },
    {
        name: 'customServiceAllList',//客户全部物流产品ship
        ajaxRequest: HttpGetCustomServiceAllList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.carrierGroupCode}`,
            attach: item,
        })),
    },
    {
        name: 'serviceProductAllList',//所有物流产品服务ship
        ajaxRequest: HttpGetAllServiceProductList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.code}`,
            attach: item,
        })),
    },
    {
        name: 'customServiceProductActiceList',//客户有效物流产品服务ship
        ajaxRequest: HttpGetCustomServiceProductActiceList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.code}`,
            attach: item,
        })),
    },
    {
        name: 'customServiceProductAllList',//客户全部物流产品服务ship
        ajaxRequest: HttpGetCustomServiceProductAllList,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.code}`,
            attach: item,
        })),
    },
    {
        name: 'carrierServiceAllList',//所有承运商服务ship
        ajaxRequest: HttpGetProductServiceByOrg,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.carrierServiceCode}`,
            attach: item,
        })),
    },
    {
        name: 'carrierAllList',//所有承运商服务ship
        ajaxRequest: HttpGetProductByOrg,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: `${item.carrierCode}`,
            attach: item,
        })),
    },
    {
        name: 'carrierAll',//所有承运商配置
        ajaxRequest: HttpCarrierAll,
        interceptResponse: data => data.map(item => ({
            value: item.carrierCode,
            label: item.carrierName ? `${item.carrierCode}(${item.carrierName})` : item.carrierCode,
            attach:{
                carrierServiceCode:item.carrierServiceCode,
                id:item.id
            }})),
    },
    {
        name: 'importerList', // 进口商
        ajaxRequest: HttpGetImporterList,
        interceptResponse: data => data.content.map(item => ({
            value: item.id,
            label: item.name,
            attach: {
                ...item
            }
        })),
        formData: {
            page: 1,
            rows: 1000
        }
    },
    {
        name: 'systemPortList', // 港口
        ajaxRequest: HttpGetSystemPortList,
        interceptResponse: data => data.content.map(item => ({
            value: item.id,
            label: item.title,
            attach: {
                ...item
            }
        })),
        formData: {
            page: 1,
            rows: 1000
        }
    },
    {
        name: 'companyList', // 货代公司
        ajaxRequest: HttpGetCompany,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: item.name,
            attach: {
                ...item
            }
        })),
        formData: {
            serviceType: 3
        }
    },
    {
        name: 'allWareHouseList',
        ajaxRequest: HttpGetAllWareHouse,
        interceptResponse: data => data.content.map(item => ({
            value: item.id,
            label: item.title,
            attach: {
                ...item
            }
        })),
        formData: {
            page: 1,
            rows: 1000
        }
    },
    {
        name: 'allProduct',
        ajaxRequest: HttpGetAllProduct,
        interceptResponse: data => data.map(item => ({
            value: item.id,
            label: item.name,
            attach: {
                ...item
            }
        }))
    },
    {
        name: 'cusBillTypeList',//客户自定义费用类型
        ajaxRequest: HttpBillTypeChoseList,
        interceptResponse: data => data.map(item => ({
            value: item.type, label: item.name, attach: {
                id: item.id,
                status: item.status,
            }
        })),
    },
    {
        name: 'insuranceList',//保险产品下拉
        ajaxRequest: HttpFindAllByInsuranceList,
        interceptResponse: data => data.map(item => ({
            value: item.id, label: item.serviceName+'('+item.serviceCode+')', attach: {
                status: item.status,
                serviceCode:item.serviceCode,
            }
        })),
    },
]
export default mixins(list)
